import { defineStore } from 'pinia'


const useSysStore = defineStore('sys', {
  state: () => ({
    isSmallScreen: false,
    isInMp: false,
    navTitle: '' as (string | undefined)
  }),
  actions: {
    setIsSmallScreen(isSmallScreen: boolean) {
      this.isSmallScreen = isSmallScreen
    },
    setIsInMp(isInMp: boolean) {
      this.isInMp = isInMp
    },
    setNavTitle(val?: string) {
      this.navTitle = val
    }
  },
})

export default useSysStore
